import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './FeedList.scss';
import EditButton from './EditButton';
import AddButton from './AddButton';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';

class FeedList extends PureComponent {
  actionFormatter = (cell, feed) => (
    <EditButton
      feed={feed}
      onEdit={this.props.onEdit}
      onDelete={this.props.onDelete}
    />
  );

  createCustomInsertButton = () => <AddButton />;

  render() {
    const { list, error, success } = this.props;

    const options = {
      insertBtn: this.createCustomInsertButton,
      defaultSortName: 'name',
      defaultSortOrder: 'asc',
    };

    return (
      <div className="feed-list-container">
        {error && <ErrorMessage error={error} />}
        {success && <SuccessMessage success={success} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn
            isKey
            dataField="name"
            dataSort
            filter={{ type: 'TextFilter', defaultValue: '' }}
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="feedType" dataSort>
            Feed Type
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(_, feed) =>
              // api feeds have url and csv feeds have filename
              feed.config?.url || feed.config?.fileName || ''
            }
          >
            File Name / Url
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(_, feed) =>
              // api feeds have url and csv feeds have filename
              feed.config?.type || ''
            }
          >
            Type
          </TableHeaderColumn>
          <TableHeaderColumn dataField="online">Online</TableHeaderColumn>
          <TableHeaderColumn dataField="inStore">In-Store</TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(_, feed) =>
              // api feeds have url and csv feeds have filename
              feed.config?.inventoryId || ''
            }
          >
            Inventory ID
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

FeedList.propTypes = {
  error: PropTypes.any,
  success: PropTypes.any,
  list: PropTypes.array,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default withRouter(FeedList);
